export const PLATE_CHARACTER_OPTIONS = [
  { value: 'ب', text: 'ب' },
  { value: 'ج', text: 'ج' },
  { value: 'د', text: 'د' },
  { value: 'ژ', text: 'ژ' },
  { value: 'س', text: 'س' },
  { value: 'ص', text: 'ص' },
  { value: 'ط', text: 'ط' },
  { value: 'ع', text: 'ع' },
  { value: 'ق', text: 'ق' },
  { value: 'ک', text: 'ک' },
  { value: 'گ', text: 'گ' },
  { value: 'ل', text: 'ل' },
  { value: 'م', text: 'م' },
  { value: 'ن', text: 'ن' },
  { value: 'و', text: 'و' },
  { value: 'ه', text: 'ه' },
  { value: 'ی', text: 'ی' }
]
export const CREDENTIAL_TYPES = [
  { id: 1, title: 'کارت سلامت' },
  { id: 2, title: 'کارت هوشمند راننده' },
  { id: 3, title: 'کارت هوشمند ناوگان' },
  { id: 4, title: 'گواهینامه' },
  { id: 5, title: 'کارت شناسایی وسیله نقلیه' },
  { id: 6, title: 'کارت ملی' }
]
